module.exports = __webpack_public_path__ + "static/index/img/baikal-302.dc1430fe.jpg";